var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountBalanceWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1519_14688",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.644531,
    width: 24,
    height: 20.7123,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1519_14688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 18.7676C4.45 18.7676 3.97917 18.5986 3.5875 18.2606C3.19583 17.9226 3 17.5163 3 17.0416V4.95943C3 4.48477 3.19583 4.07843 3.5875 3.74042C3.97917 3.40241 4.45 3.2334 5 3.2334H19C19.55 3.2334 20.0208 3.40241 20.4125 3.74042C20.8042 4.07843 21 4.48477 21 4.95943V7.11696H19V4.95943H5V17.0416H19V14.8841H21V17.0416C21 17.5163 20.8042 17.9226 20.4125 18.2606C20.0208 18.5986 19.55 18.7676 19 18.7676H5ZM13 15.3156C12.45 15.3156 11.9792 15.1466 11.5875 14.8086C11.1958 14.4706 11 14.0642 11 13.5896V8.41148C11 7.93682 11.1958 7.53049 11.5875 7.19247C11.9792 6.85446 12.45 6.68545 13 6.68545H20C20.55 6.68545 21.0208 6.85446 21.4125 7.19247C21.8042 7.53049 22 7.93682 22 8.41148V13.5896C22 14.0642 21.8042 14.4706 21.4125 14.8086C21.0208 15.1466 20.55 15.3156 20 15.3156H13ZM20 13.5896V8.41148H13V13.5896H20ZM16 12.295C16.4167 12.295 16.7708 12.1692 17.0625 11.9175C17.3542 11.6658 17.5 11.3601 17.5 11.0005C17.5 10.6409 17.3542 10.3353 17.0625 10.0836C16.7708 9.83186 16.4167 9.706 16 9.706C15.5833 9.706 15.2292 9.83186 14.9375 10.0836C14.6458 10.3353 14.5 10.6409 14.5 11.0005C14.5 11.3601 14.6458 11.6658 14.9375 11.9175C15.2292 12.1692 15.5833 12.295 16 12.295Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBalanceWallet);
export default __webpack_public_path__ + "static/media/account_balance_wallet.a98766663a5d72088d6d64d11b374a7b.svg";
export { ForwardRef as ReactComponent };